// Mode de chiffrement SMTP DÉDUIT DU PORT — miroir front de
// backend/communication/smtp_security.py (table unique, back+front cohérents).
//   465 → ssl (SSL/TLS implicite) · 587 → starttls · 25 → none · autre → starttls
export function smtpModeForPort(port) {
  const p = parseInt(port, 10) || 0;
  if (p === 465) return "ssl";
  if (p === 25) return "none";
  if (p === 587) return "starttls";
  return "starttls";
}

export function smtpModeLabel(mode) {
  if (mode === "ssl") return "SSL/TLS implicite";
  if (mode === "none") return "Aucun chiffrement";
  return "STARTTLS";
}

// (use_tls, use_ssl) cohérents avec le mode — pour stockage/affichage (le modèle
// MailSender garde ces champs ; ils deviennent DÉRIVÉS du port, plus saisis).
export function smtpFlagsForPort(port) {
  const mode = smtpModeForPort(port);
  return { use_tls: mode === "starttls", use_ssl: mode === "ssl" };
}

// Détection de l'OPÉRATEUR SMTP depuis le host — SOURCE UNIQUE (un seul mapping,
// réutilisé pour le nom affiché des senders). Le type d'intégration s'appelle
// génériquement "SMTP" ; l'opérateur est dérivé à l'affichage (ex. smtp.ionos.fr
// → "IONOS"), sans toucher la valeur `name` stockée du sender.
const SMTP_OPERATORS = [
  [/\bionos\b/, "IONOS"],
  [/mandrill/, "Mandrill"],
  [/sendgrid/, "SendGrid"],
  [/gmail|googlemail/, "Gmail"],
  [/\bovh\b/, "OVH"],
  [/outlook|office365|microsoft|hotmail/, "Outlook"],
];

export function smtpOperatorForHost(host) {
  const h = String(host || "").trim().toLowerCase();
  if (!h) return "";
  for (const [re, name] of SMTP_OPERATORS) if (re.test(h)) return name;
  // Fallback générique : 2e label du domaine, capitalisé (smtp.example.com →
  // "Example") ; à défaut le host brut.
  const labels = h.replace(/^(smtp|mail|ssl\d*)\./, "").split(".").filter(Boolean);
  const core = labels.length >= 2 ? labels[labels.length - 2] : labels[0];
  return core ? core.charAt(0).toUpperCase() + core.slice(1) : h;
}

// Nom affiché d'un sender SMTP : "SMTP (Opérateur)" — ex. "SMTP (IONOS)",
// "SMTP (Mandrill)". Cosmétique/dérivé du host, n'écrase pas le `name` stocké.
export function smtpSenderDisplayName(host) {
  const op = smtpOperatorForHost(host);
  return op ? `SMTP (${op})` : "SMTP";
}
